/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob03IndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob03IndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false
});

export const whseJob03IndexFetchWhseJob03IndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob03IndexFetchWhseJob03IndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob03IndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const whseJob03IndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob03IndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob03IndexTypes.WHSE_JOB03_INDEX_RESET_TIMESTAMP]: whseJob03IndexResetTimestamp,
  [WhseJob03IndexTypes.WHSE_JOB03_INDEX_FETCH_WHSE_JOB03_INDEX_LOADING]: whseJob03IndexFetchWhseJob03IndexLoading,
  [WhseJob03IndexTypes.WHSE_JOB03_INDEX_FETCH_WHSE_JOB03_INDEX_SUCCESS]: whseJob03IndexFetchWhseJob03IndexSuccess,
  [WhseJob03IndexTypes.WHSE_JOB03_INDEX_ADD_SELECTED_DOCUMENTS]: whseJob03IndexAddSelectedDocuments,
  [WhseJob03IndexTypes.WHSE_JOB03_INDEX_REMOVE_SELECTED_DOCUMENTS]: whseJob03IndexRemoveSelectedDocuments,
  [WhseJob03IndexTypes.WHSE_JOB03_INDEX_SET_WORKSPACE_VISIBLE]: whseJob03IndexSetWorkspaceVisible
});
